// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getStorage, ref, uploadBytes} from "firebase/storage";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
// Your web app's Firebase configuration
const firebaseConfig = {
    apiKey: "AIzaSyBCQpTjGvPaLSLDTAaL0M0DS0lKBYHuGi8",
    authDomain: "nazarovgeoweb.firebaseapp.com",
    projectId: "nazarovgeoweb",
    storageBucket: "nazarovgeoweb.appspot.com",
    messagingSenderId: "691901483196",
    appId: "1:691901483196:web:b7bd4d3e4de7bae54928b9"
  };

// Initialize Firebase
export const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const storage = getStorage(app);